// src/leaflet-global.ts

// Import Leaflet's ESM namespace (read-only object with all exports)
import * as LeafletNS from "leaflet/dist/leaflet-src.esm.js";

type LeafletNamespace = typeof import("leaflet");
type MutableLeafletNamespace = LeafletNamespace & Record<string, unknown>;

// Create or reuse a plain, extensible global object for L
const windowWithLeaflet = window as unknown as { L?: MutableLeafletNamespace };
const globalL: MutableLeafletNamespace = windowWithLeaflet.L ?? ({} as MutableLeafletNamespace);

// Copy all ESM exports onto the plain object so it behaves like the Leaflet namespace
Object.assign(globalL, LeafletNS);

// Publish as the global L for plugins like Leaflet.PM to patch (e.g., L.PM = …)
windowWithLeaflet.L = globalL;

// Re-export runtime API for consumers importing from 'leaflet' (via alias)
export * from "leaflet/dist/leaflet-src.esm.js";
export default globalL;

// (Types still come from the official package through your .d.ts shim)
